import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const OFFSET = 90; // espaço da barra de navegação fixa

/**
 * Rola até a âncora (#loja...) ao abrir a página ou clicar em um link interno;
 * sem âncora, volta ao topo. Como imagens carregando acima do destino mudam a altura da
 * página durante a rolagem suave, reajusta a posição por ~3s (a menos que o usuário role).
 */
const ScrollToHash = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo(0, 0);
      return undefined;
    }
    const id = decodeURIComponent(hash.slice(1));
    const timers = [];
    let cancelled = false;
    const stop = () => { cancelled = true; };
    const events = ['wheel', 'touchstart', 'keydown'];
    events.forEach((e) => window.addEventListener(e, stop, { passive: true }));

    const fix = () => {
      const el = document.getElementById(id);
      if (!el || cancelled) return;
      if (Math.abs(el.getBoundingClientRect().top - OFFSET) > 40) {
        window.scrollTo({ top: window.scrollY + el.getBoundingClientRect().top - OFFSET, behavior: 'auto' });
      }
    };

    let tries = 0;
    const waiter = setInterval(() => {
      const el = document.getElementById(id);
      if (el || ++tries > 80) {
        clearInterval(waiter);
        if (!el) return;
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        [900, 1600, 2600].forEach((ms) => timers.push(setTimeout(fix, ms)));
      }
    }, 50);

    return () => {
      clearInterval(waiter);
      timers.forEach(clearTimeout);
      events.forEach((e) => window.removeEventListener(e, stop));
    };
  }, [pathname, hash]);

  return null;
};

export default ScrollToHash;
